<template>
  <div>
    <router-view></router-view>
    <nav id="nav">
      <ul>       
        <router-link tag="li" to="/home">
          <Icon type="md-home" />
          <p>首页</p>
        </router-link>
        <router-link tag="li" to="/locate">
          <Icon type="md-pin" />
          <p>定位</p>
        </router-link>
        <router-link tag="li" to="/scheduling/apply">
          <!-- <Icon type="md-person" /> -->
          <Icon type="ios-time" />
          <p>调度</p>
        </router-link>
        <router-link tag="li" to="/doc">
          <!-- <Icon type="md-person" /> -->
          <Icon type="md-person" />
          <p>我的</p>
        </router-link>
      </ul>
    </nav>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {};
  },
  methods: {
    
  },
  mounted() {
  },
};
</script>
<style lang="">

#mylist {
  position: absolute;
  top: 50px;
  bottom: 56px;
  left: 0px;
  right: 0px;
  overflow: auto;
}
#mylist::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 0px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
#mylist::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #8a8a8a;
}
#mylist::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px #00000033;
  border-radius: 10px;
  background: #ededed;
}
#mylist .input {
  width: 100%;
  border: solid 1px #ddd;
  padding: 4px 10px;
  height: 30px;
  border-radius: 4px;
}

#mylist .wrap {
  background: #fff;
  width: 92%;
  margin: 0 auto 10px auto;
  padding: 20px;
  line-height: 2;
}
#detali {
  line-height: 2;
}
#mylist .wrap .label,
#detali .wrap .label {
  color: #999;
  display: inline-block;
}
#mylist .wrap .update {
  margin-right: 20px;
  margin-top: 10px;
  display: inline-block;
  float: right;
}
#mylist .wrap .update i {
  margin-right: 6px;
}
#mylist .wrap .detail {
  margin-top: 10px;
  display: inline-block;
}

#mylist .time {
  width: 92%;
  margin: 20px auto 10px auto;
}
#mylist .time span {
  margin-right: 6px;
}

#detali .del {
  margin-top: 10px;
  color: #f63;
}

/*图片控件 */
#bigImg {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  background: #333;
  z-index: 222;
}
#closeBtn {
  position: absolute;
  right: 10px;
  top: 10px;
}
#closeImg {
  position: absolute;
  top: -4px;
  right: -4px;
  z-index: 11;
  font-size: 20px;
  color: #fff;
  background: #616161;
  border-radius: 10px;
}
#nav {
  background: #fff;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 54px;
}
#nav ul {
  display: flex;
  margin-top: 8px;
}
#nav ul li {
  width: 25%;
  text-align: center;
}
#nav ul li.router-link-active i,
#nav ul li.router-link-active p {
  color: #1e92f0;
}
#nav ul li i {
  font-size: 20px;
  color: #999;
}
#nav ul li p {
  font-size: 13px;
}
#bvbutton {
  width: 130px;
  height: 130px;
  background: #476eee;
  background: linear-gradient(180deg, #6b8af0, #476eee);
  border-radius: 50%;
  box-shadow: 4px 4px 10px #5489fc;
  margin: 100px auto 20px auto;
  color: #fff;
  text-align: center;
  overflow: hidden;
}
.bvgreen{
  background: linear-gradient(180deg, #1cafdb, #097ead)!important;
}
#bvbutton:active {
  background: #7795f8;
}
#bvbutton #title {
  font-size: 18px;
  margin-top: 45px;
  font-weight: 700;
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue